import classNames from 'classnames/bind';
import { useToast } from 'common/searchBox/Toast';
import { getClickCodeWithPrefix } from 'common/utils';
import { SearchType } from 'contexts/searchParams';
import React from 'react';
import styles from './index.module.scss';
import { areaCodeBySearchType } from './utils';

const cx = classNames.bind(styles);

interface IProps {
  isChecked: boolean;
  searchType: SearchType;
  tooltip?: string;
  disabledSubmit?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onToggle: () => void;
}

export default function Footer({
  isChecked,
  searchType,
  tooltip,
  disabledSubmit,
  onCancel,
  onConfirm,
  onToggle,
}: IProps) {
  const [message, showToast] = useToast();

  const withPrefix = getClickCodeWithPrefix(
    areaCodeBySearchType.get(searchType) || '',
  );

  return (
    <div className={cx('Footer')}>
      <div className={cx('btns')}>
        <div className={cx('toggle_save')}>
          <button
            type="button"
            className={cx('btn')}
            aria-checked={isChecked}
            data-event-nlog="click"
            data-event-area-code={withPrefix('filtersave')}
            onClick={onToggle}
          />
          {tooltip && (
            <button
              type="button"
              className={cx('notice')}
              data-event-nlog="click"
              data-event-area-code={withPrefix('filterinfo')}
              onClick={() => showToast(tooltip)}
            >
              선택 조건
              <br />
              저장
            </button>
          )}
          {message && (
            <div className={cx('popup')}>
              {message.split('\\n').map((text, index) => (
                <React.Fragment key={index}>
                  {text}
                  <br />
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
        <button
          className={cx('cancel')}
          type="button"
          data-event-nlog="click"
          data-event-area-code={withPrefix('cancel')}
          onClick={onCancel}
        >
          취소
        </button>
        <button
          className={cx('submit')}
          type="submit"
          data-event-nlog="click"
          data-event-area-code={withPrefix('apply')}
          onClick={onConfirm}
          disabled={disabledSubmit}
        >
          적용
        </button>
      </div>
    </div>
  );
}
